<template>
    <main class="p-5 mt-2">
        <div class="top-header flex justify-between items-center align-items-center">
            <div class="text-xl font-semibold">{{ $t('webshopOrderManager') }}</div>
            <select v-model="selectedWebshop" @change="changeWebshop" class="px-5 py-1 rounded-sm focus:outline-none bg-white border text-xs text-gray-700">
                <option :value="webshop.uuid" v-for="webshop in GET_WEBSHOPS.results" :key="webshop.uuid">{{ webshop.shop_name }}</option>
            </select>
        </div>
        <div class="mt-10">
            <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4">
                <div class="col-span-3 flex flex-col items-center align-items-center space-x-4 border shadow-sm rounded-md shadow-sm overflow-hidden">
                    <div class="flex justify-between items-center align-items-center w-full bg-light-teal p-2 border-b">
                        <span class="text-sm font-semibold">{{ $t('orderRule') }}</span>
                    </div>
                    <div class="flex flex-col md:flex-row w-full">
                        <div class="flex flex-col w-full md:w-1/2 p-2">
                            <div class="grid grid-cols-1 sm:grid-cols-2">
                                <div class="flex space-x-3 mb-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-theme-green" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="text-sm text-gray-600">{{ $t('supplierSelection') }}</span>
                                    <svg @click="openSupplierModal = true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-icon-blue cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </div>
                                <div class="flex space-x-3 mb-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-theme-green" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="text-sm text-gray-600">{{ $t('brandPreference') }}</span>
                                    <svg @click="openBrandModal = true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-icon-blue cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </div>
                                <!-- <div class="flex space-x-3 mb-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-theme-green" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="text-sm text-gray-600">{{ $t('fastestDeliveryTime') }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-icon-blue cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </div>
                                <div class="flex space-x-3 mb-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-theme-green" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="text-sm text-gray-600">{{ $t('brandPreference') }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-icon-blue cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </div> -->
                            </div>
                        </div>
                        <div class="flex flex-col w-full md:w-1/2">
                            
                        </div>
                    </div>
                    <!-- <div class="flex justify-center mb-5 mt-6">
                        <button class="focus:outline-none bg-theme-blue text-sm px-3 py-1 rounded-md shadow-md text-white">{{ $t('saveSetting') }}</button>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="absolute bg-red-30 inset-0 z-10" @click="removeEvent" v-if="showActionBox"></div>
        <div class="absolute bg-red-30 inset-0 z-10" @click="showFilter = false" v-if="showFilter"></div>
        <div class="absolute bg-red-30 inset-0 z-10" v-if="statusUpdate" @click="hideStatus"></div>

        <div class="mt-10 mb-20">
            <span v-if="GET_WEBSHOP_FILTER.length > 0" class="flex block text-gray-400 justify-end items-center text-xs mb-2">
                <span class="mr-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                    </svg>
                </span>
                {{ $t('activeFilter') }}
            </span>
            <div class="flex flex-wrap md:space-x-4 justify-end mb-2 pr-2">
                <span class="flex justify-between space-x-3 font-semibold text-blue-900 text-xs" v-for="(item, i) in GET_WEBSHOP_FILTER" :key="i">
                    <span>
                        {{ item.mode === 'date' ? $t('date') : null }}
                        {{ item.mode === 'amount' ? $t('total') : null }}
                        {{ item.mode === 'status' ? $t('status') : null }}
                    </span>
                    <span class="cursor-pointer" @click="removeFilterSearch(item)">x</span>
                </span>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4">
                <div class="col-span-3 flex flex-col items-center align-items-center space-x-4 border shadow-sm rounded-md shadow-sm overflow-hidden">
                    <div class="flex justify-between items-center w-full bg-light-teal p-2 border-b">
                        <h2 class="text-sm font-semibold">{{ $t('webshopOrderOverview')}}</h2>
                        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
                            <div class="flex items-center space-x-3">
                                <!-- <input placeholder="Search" type="text" class="w-full rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;"> -->
                                <select v-model="orderingText" @change="SortByChange" class="w-full bg-white rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;">
                                    <option value="" selected disabled>{{ $t('sortBy') }}</option>
                                    <option value="delivery_date">{{ $t('deliveryDateAsc')}}</option>
                                    <option value="-delivery_date">{{ $t('deliveryDateDsc')}}</option>
                                    <option value="created_on">{{ $t('orderDateAsc')}}</option>
                                    <option value="-created_on">{{ $t('orderDateDesc')}}</option>
                                    <option value="items_total">{{ $t('amountAsc')}}</option>
                                    <option value="-items_total">{{ $t('amountDesc')}}</option>
                                </select>
                                <div class="w-1/2 relative">
                                    <button class="flex items-center md:space-x-3 text-xs bg-white rounded p-2 border focus:outline-none" @click="showFilter = !showFilter">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                                            </svg>
                                        </span>
                                        <span class="whitespace-nowrap">{{ $t('filter') }}</span>
                                    </button>
                                    <div class="absolute w-52 bg-white z-50 rounded border shadow mt-0 -ml-40 md:-ml-20" v-if="showFilter">
                                        <FilterComponent data='webshop' 
                                        @hideAdvanceFilter="showFilter = false"
                                        @performMultipleFilter="multipleFilterResult"
                                        @filterDate="filterDate"
                                        @filterStatus="filterStatus"
                                        @filterOrderAmount="filterOrderAmount"
                                        @filterOrderNumber="filterOrderNumber" 
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <input :placeholder="$t('search')" @input="searchInputTrigger" type="text" class="w-full rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;">
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full">
                        <div class="block w-full overflow-x-auto md:overflow-x-hidden overflow-y-hidden">
                            <span v-if="loading" class="flex justify-center w-full">
                                <svg class="text-center animate-spin mr-2 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </span>
                            <table :class="GET_WEBSHOP_ORDERS && GET_WEBSHOP_ORDERS.results.length > 0 ? 'mb-4' : ''" class="table md:table-fixed w-full" border="4">
                                <thead>
                                    <tr>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="flex justify-between items-center text-xs text-gray-400">{{ $t('orderNumber') }} <span class="flex flex-col"><span @click="sortOrderNumberAsc" class="cursor-pointer"><img src="./../../assets/images/arrow-up.png" alt=""></span><span @click="sortOrderNumberDesc" class="cursor-pointer"><img src="./../../assets/images/arrow-down.png" alt=""></span></span></span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="text-xs text-gray-400">{{ $t('supplier') }}</span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="flex justify-between items-center text-xs text-gray-400">{{ $t('orderDate') }} <span class="flex flex-col"><span @click="sortWebshopOrderDateAsc" class="cursor-pointer"><img src="./../../assets/images/arrow-up.png" alt=""></span><span @click="sortWebshopOrderDateDesc" class="cursor-pointer"><img src="./../../assets/images/arrow-down.png" alt=""></span></span></span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="flex justify-between items-center text-xs text-gray-400">{{ $t('customerName') }}<span class="flex flex-col"><span @click="sortCustomerNameAsc" class="cursor-pointer"><img src="./../../assets/images/arrow-up.png" alt=""></span><span @click="sortCustomerNameDesc" class="cursor-pointer"><img src="./../../assets/images/arrow-down.png" alt=""></span></span></span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="text-xs text-gray-400">{{ $t('status') }}</span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="flex justify-between text-xs text-gray-400">{{ $t('deliveryDate') }} <span class="flex flex-col"><span @click="sortWebshopOrderDeliveryDateAsc" class="cursor-pointer"><img src="./../../assets/images/arrow-up.png" alt=""></span><span @click="sortWebshopOrderDeliveryDateDesc" class="cursor-pointer"><img src="./../../assets/images/arrow-down.png" alt=""></span></span></span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="flex justify-between text-xs text-gray-400">{{ $t('total') }} <span class="flex flex-col"><span @click="sortWebshopOrderTotalAsc" class="cursor-pointer"><img src="./../../assets/images/arrow-up.png" alt=""></span><span @click="sortWebshopOrderTotalDesc" class="cursor-pointer"><img src="./../../assets/images/arrow-down.png" alt=""></span></span></span></th>
                                        <th class="text-left whitespace-nowrap p-2 md:p-0"><span class="text-xs text-gray-400">{{ $t('action') }}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="webshop in GET_WEBSHOP_ORDERS.results" :key="webshop.uuid">
                                        <WebshopOrderTableVue 
                                            :webshop="webshop"
                                            :shopStatus="shopStatus"
                                            @toggleEvent="toggleEventAction"
                                            @emitDeleteEvent="emitDeleteEvent"
                                            @emitUpdateEvent="emitUpdateEvent"
                                            @emitViewEvent="emitViewEvent"
                                            @updateWebshopOrder="openStatusUpdateModal"
                                        />
                                        <!-- <td>
                                            <span class="flex items-center cursor-pointer space-x-3 font-semibold whitespace-nowrap p-2 md:p-0 text-sm text-gray-400">
                                                <span class="mr-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                    <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                            <div class="flex justify-between p-2 text-xs mb-20">
                                <div class="flex">
                                    <select @change="shopResultNumber" class="w-full bg-white rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;">
                                        <option selected disabled>{{ $t('show') }}</option>
                                        <option :value="i*100" v-for="i in 5" :key="i">{{ i*100 }}</option>
                                    </select>
                                </div>
                                <div class="flex" v-if="GET_WEBSHOP_ORDERS">
                                    <v-pagination
                                        v-model="GET_WEBSHOP_ORDERS.page_number"
                                        :pages="GET_WEBSHOP_ORDERS.total_pages"
                                        :range-size="1"
                                        active-color="#DCEDFF"
                                        @update:modelValue="changePageNumber"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalBox v-if="openDeletedModal" :title="$t('deleteWebshopOrder')" @handleClose='openDeletedModal = false' :backdropOff='false'>
            <div class="flex flex-col w-full overflow-x-hidden">
                <h1 class="text-gray-500">{{ $t('deleteOrder') }}?</h1>
                <div class="flex justify-end mt-2">
                    <button @click="openDeletedModal = false" class="flex justify-center rounded whitespace-nowrap align-items-center  px-10 py-2 text-gray-100 text-gray-400 text-xs cursor-pointer border">{{ $t('cancel') }}</button>
                    <button @click="proceedDeletion" :disabled='deleting' type="submit" class="flex justify-center rounded whitespace-nowrap align-items-center bg-red-500 px-10 py-2 text-white text-xs cursor-pointer border">
                        <span class="flex" v-if="deleting">
                            <svg class="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            {{ $t('deleting') }}
                        </span>
                        <span v-else>{{ $t('yesDelete') }}</span>
                    </button>
                </div>
            </div>
        </ModalBox>
        <ModalBox v-if="openStatusModal" :title="$t('updateWebshop')" @handleClose='openStatusModal = false' :backdropOff='true'>
            <div class="flex flex-col w-full overflow-x-hidden">
                <h1 class="text-gray-500">{{  $t('updateSupplierOrderStatus') }}?</h1>
                <div class="flex justify-end mt-2">
                    <button :disabled='confirming' @click="updateWebshopOrder(false)" class="flex justify-center rounded whitespace-nowrap align-items-center  px-10 py-2 bg-theme-yellow text-gray-800 text-xs cursor-pointer border">
                        <span class="flex" v-if="confirming">
                            <svg class="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            {{ $t('updating') }}
                        </span>
                        <span v-else>{{ $t('no') }}</span>
                    </button>
                    <button @click="updateWebshopOrder(true)"  :disabled='confirmingYes' type="submit" class="flex justify-center rounded whitespace-nowrap align-items-center bg-green-500 px-10 py-2 text-white text-xs cursor-pointer border">
                        <span class="flex" v-if="confirmingYes">
                            <svg class="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            {{ $t('updating') }}
                        </span>
                        <span v-else>{{ $t('yes') }}</span>
                    </button>
                </div>
            </div>
        </ModalBox>
        <ModalBox v-if="openSupplierModal" width="md:w-2/5 w-full" @handleClose='openSupplierModal = false' :backdropOff='true'>
            <div class="flex flex-col w-full overflow-x-hidden">
                <div class="flex justify-center mx-4 font-semibold bg-deep-teal text-theme-blue rounded-md">
                    <div class="text-center p-2 text-sm">{{ $t('supplierHeading') }}</div>
                </div>
                <div class="flex flex-col pl-10 mt-5 mb-5">
                    <Container :drop-class="'text-xl'" orientation="vertical" @drag-end="onDragEnd" @drop="onDrop">            
                        <Draggable class="text-xl" v-for="(item, i) in items" :key="item.id">
                            <div class="flex">
                                <!-- {{ $services.helpers.removeUnderscoreCap(item.rule_name) }} -->
                                <span class="text-lg text-theme-blue font-semibold mr-2">{{ i + 1 }}</span>
                                <span class="text-base text-gray-800">
                                    {{ item.rule_name === 'cheapest_price' ? $t('cheapestProductPrice') : null }}
                                    {{ item.rule_name === 'fastest_delivery' ? $t('fastestDeliveryTime') : null }}
                                    {{ item.rule_name === 'cheapest_delivery' ? $t('cheapestDeliveryPrice') : null }}
                                </span>
                            </div>
                        </Draggable>
                    </Container>
                    <div class="form-group w-full mb-3">
                        <div class="flex justify-center px-10 mt-6">
                            <button :disabled="saving" @click="saveOrderPriority" class="focus:outline-none text-sm px-3 py-2 rounded-md shadow-md bg-theme-blue text-white">
                                <span v-if="saving">{{ $t('pleaseWait') }}...</span>
                                <span v-else>{{ $t('saveSetting') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBox>
        <ModalBox v-if="openBrandModal" width="md:w-2/5 w-full" @handleClose='openBrandModal = false' :backdropOff='true'>
            <div class="flex flex-col w-full overflow-x-hidden">
                <div class="absolute bg-red-30 inset-0 z-10" v-if="supplierModal" @click="supplierModal = false"></div>
                <div class="flex justify-center mx-4 font-semibold bg-deep-teal text-theme-blue rounded-md">
                    <div class="text-center p-2 text-sm">{{ $t('brandHeading') }}</div>
                </div>
                <div class="flex flex-col md:flex-row md:justify-between md:space-x-3 mt-10">
                    <form class="flex flex-col w-full" @submit.prevent="addBrandPreference">
                        <div class="form-group w-full mb-3">
                            <label for="supplier" class="text-sm text-gray-600">{{ $t('brand')}}</label>
                            <input type="text" v-model.trim="form.brand" class="w-full rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;" required>
                            <!-- <div class="relative w-full">
                                <div v-if="supplierModal && supplierResult.length > 0" class="absolute w-full bg-white z-50 rounded border shadow-2xl top-rem">
                                    <ul>
                                        <li class="py-1 pl-2 hover:bg-gray-100 text-gray-700 cursor-pointer text-sm" v-for="(item, i) in supplierResult.slice(0, 5)" :key="i" @click="setSupplier(item)">{{ item.supplier.name }}</li>
                                    </ul>
                                </div>
                            </div> -->
                        </div>
                        <div class="form-group w-full mb-3">
                            <label for="supplier" class="text-sm text-gray-600">{{ $t('supplier')}}</label>
                            <input type="text" v-model="supplierName" @input="searchSupplier" @focus="supplierModal = true" class="w-full rounded p-2 border focus:outline-none focus:border-blue-300 text-gray-600 text-xs" style="outline: currentcolor none medium;" required>
                            <div class="relative w-full">
                                <div v-if="supplierModal && supplierResult.length > 0" class="absolute w-full bg-white z-50 rounded border shadow-2xl top-rem">
                                    <ul>
                                        <li class="py-1 pl-2 hover:bg-gray-100 text-gray-700 cursor-pointer text-sm" v-for="(item, i) in supplierResult.slice(0, 5)" :key="i" @click="setSupplier(item)">{{ item.supplier.name }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full mb-3">
                            <div class="flex justify-center px-10 mt-6">
                                <button :disabled="saving" class="focus:outline-none bg-theme-blue text-sm px-3 py-2 rounded-md shadow-md text-white">
                                    <span v-if="saving">{{ $t('pleaseWait') }}</span>
                                    <span v-else>
                                        {{ $t('saveSetting') }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="flex flex-col w-full md:h-96 bg-gray-100">
                        <span class="text-sm text-gray-600 text-center p-2">{{ $t('saveMapping') }}</span>
                        <div id="mapping-scroll" class="flex flex-col overflow-y-scroll">
                            <table>
                                <thead class="hidden">
                                    <tr>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="" v-for="item in brandPreference" :key="item.uuid">
                                        <td class="flex space-x-3 items-center">
                                            <span class="cursor-pointer" @click="removeBrand(item)">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                                </svg>
                                            </span>
                                            <span class="text-xs">{{ getSupplierInfo(item.supplier) }}</span>
                                        </td>
                                        <td><span class="text-xs">{{ $services.helpers.capitalizeNames(item.brand_preference) }}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </ModalBox>
    </main>
</template>

<script>
import { mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import Bus from '../../bus'
import ModalBox from '@/components/Modal'
import WebshopOrderTableVue from './minicomponent/WebshopOrderTable'
import FilterComponent from './minicomponent/FilterComponent'
import VPagination from '@hennge/vue3-pagination'
import '@hennge/vue3-pagination/dist/vue3-pagination.css'
import { Container, Draggable } from "vue3-smooth-dnd"

export default {
    name : 'WebshopOrders',
    components : { 
        WebshopOrderTableVue, 
        ModalBox, 
        FilterComponent, 
        VPagination,
        Container, 
        Draggable 
    },
    data () {
        return {
            loading : true,
            processing : true,
            showFilter : false,
            openDeletedModal : false,
            showActionBox : false,
            deleting : false,
            confirming : false,
            confirmingYes : false,
            saving : false,
            selectedWebshop : '',
            selectedData : {},
            statusUpdate : false,
            statusUpdateData : {},
            openStatusModal : false,
            openSupplierModal : false,
            openBrandModal : false,
            shopStatus : [],
            supplierName : '',
            supplierResult : [],
            ordering : false,
            orderingText : '',
            limit : 100,
            form : {
                brand : '',
                supplier : '',
            },
            supplierModal : false,
            same : true,
            items: [],
            copyItems : [],
            brandPreference : [],
        }
    },
    watch : {
        items : function (n, o) {
            if (n) {
                this.same = this.compareObjectArray(n, this.copyItems)
            }
        }
    },
    computed : {
        ...mapGetters({
            USER_REFRESH : 'auth/USER_REFRESH',
            GET_WEBSHOPS : 'jitcontrol/GET_WEBSHOPS',
            GET_SUPPLIERS : 'jitcontrol/GET_SUPPLIERS',
            GET_WEBSHOP_ORDERS : 'jitcontrol/GET_WEBSHOP_ORDERS',
            GET_USER_INFORMATION : 'jitcontrol/GET_USER_INFORMATION',
            GET_WEBSHOP_FILTER : 'jitcontrol/GET_WEBSHOP_FILTER'
        })
    },
    mounted () { 
        this.getUserInformation() 

        Bus.on('update-sup-status-up', _ => {
            this.statusUpdate = true
        })
    },
    methods : {
        compareObjectArray (o1, o2) {
            return Object.keys(o1).length === Object.keys(o2).length 
            && Object.keys(o1).every(p => o1[p] === o2[p]);
        },
        searchSupplier () {
            this.supplierResult = this.GET_SUPPLIERS.results.filter(el => {
                return String(el.supplier.name.toLowerCase()).includes(this.supplierName.toLowerCase())
            })
        },
        setSupplier (item) {
            this.supplierName = item.supplier.name
            this.form.supplier = item.supplier.uuid
            this.supplierModal = false
        },
        hideStatus () {
            Bus.emit('update-sup-status-down')
            this.statusUpdate = false
        },
        SortByChange (e) {
            this.loading = true
            this.ordering = true
            this.orderingText = e.target.value
            const payload = {
                id : this.selectedWebshop,
                query : `?ordering=${e.target.value}&limit=${this.limit}`
            }
            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.filterSearch()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })

            // this.$store.commit('jitcontrol/SORT_BY_WEBSHOP_ORDER', { value : e.target.value })
        },
        searchInputTrigger : debounce(function (event) {
            if (event.target.value !== '') {
                this.filterSearch(event)
            } else {
                this.$store.commit('jitcontrol/FILTER_ALL_WEBSHOP_ORDER', null)
            }
        }, 500),
        filterSearch (event) {
            // this.$store.commit('jitcontrol/FILTER_WEBSHOP_ORDER_SEARCH', { value : event.target.value })
            this.loading = true
            this.ordering = false
            this.orderingText = ''
            const payload = {
                id : this.selectedWebshop,
                query : `?q=${event.target.value}&limit=${this.limit}`
            }
            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.filterSearch()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        getShopStatus () {
            const payload = {
                URL : this.selectedWebshop + this.$services.endpoints.SHOP_STATUS_MAPPING
            }
            this.$store.dispatch('jitcontrol/customGetRequest', payload)
            .then(res => {
                this.shopStatus = res.data.results
            })
            .catch(err => {
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.getShopStatus()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        getOrderRule () {
            const payload = {
                URL : this.selectedWebshop + this.$services.endpoints.ORDER_RULE_ENDPOINT
            }
            this.$store.dispatch('jitcontrol/customGetRequest', payload)
            .then(res => {
                this.items = []
                this.brandPreference = []
                if (res.data.results.length > 0) {
                    res.data.results.forEach(element => {
                        if (!element.brand_preference) {
                            this.items.push(element)
                        } else {
                            this.brandPreference.push(element)
                        }
                    });
                    this.items = this.items.sort((a, b) => a.rule_priority - b.rule_priority)
                    this.copyItems = [...this.items]
                }
            })
            .catch(err => {
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.getShopStatus()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        addBrandPreference () {
            if (this.form.brand === '' || this.form.supplier === '') {
                this.$services.helpers.notification(this.$t('fieldRequired'), 'error', this)
            } else {
                this.saving = true
                const payload = {
                    URL : this.selectedWebshop + this.$services.endpoints.ORDER_RULE_ENDPOINT,
                    supplier : this.form.supplier,
                    rule_type : 'Product',
                    rule_name : 'brand_preference',
                    brand_preference : this.form.brand
                }
                this.$store.dispatch('jitcontrol/customPostRequest', payload)
                .then(_ => {
                    this.saving = false
                    this.getOrderRule()
                    this.$services.helpers.notification(this.$t('success'), 'success', this)
                    Object.keys(this.form).forEach(element => {
                        this.form[element] = ''                        
                    })
                    this.supplierName = ''
                })
                .catch(err => {
                    this.saving = false
                    if (err.response.status === 401) {
                        this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                        .then(_ =>{
                            this.addBrandPreference()
                        })
                        .catch(_ => {
                            this.$store.commit('auth/CLEAR_AUTH_USER', null)
                            Bus.emit('sign-out')
                        })
                    } else {
                        this.$services.helpers.notification(err.response.data, 'error', this)
                    }
                })
            }
        },
        removeBrand (item) {
            this.$services.helpers.notification(this.$t('pleaseWait'), 'progress', this)
            const payload = {
                URL : this.selectedWebshop + `${this.$services.endpoints.ORDER_RULE_ENDPOINT}/${item.uuid}`,
            }
            this.$store.dispatch('jitcontrol/customDeleteRequest', payload)
            .then(res => {
                this.getOrderRule()
                this.$services.helpers.notification(this.$t('success'), 'success', this)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.removeBrand(item)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                } else {
                    this.$services.helpers.notification(err.response.data, 'error', this)
                }
            })
        },
        getSupplierInfo (uuid) {
            const filter = this.GET_SUPPLIERS.results.filter(el => el.supplier.uuid === uuid)
            if (filter.length > 0) {
                return filter[0].supplier.name
            }
            return null
        },
        saveOrderPriority () {
            if (!this.same) {
                this.saving = true
                this.items.map((el, index) => {
                    const payload = {
                        URL : this.selectedWebshop + `${this.$services.endpoints.ORDER_RULE_ENDPOINT}/${el.uuid}`,
                        rule_priority : parseInt(index + 1),
                    }
                    this.$store.dispatch('jitcontrol/customPutRequest', payload)
                    .then(res => { })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                            .then(_ =>{
                                this.saveOrderPriority()
                            })
                            .catch(_ => {
                                this.$store.commit('auth/CLEAR_AUTH_USER', null)
                                Bus.emit('sign-out')
                            })
                        } else {
                            this.$services.helpers.notification(err.response.data, 'error', this)
                        }
                    })
                })
                this.saving = false
                this.getOrderRule()
                this.$services.helpers.notification(this.$t('success'), 'success', this)
            }
        },
        getUserInformation () {
            this.loading = true
            this.$store.dispatch('jitcontrol/getUserInfo')
            .then(_ => { 
                if (this.GET_USER_INFORMATION.length > 0) {
                    const payload = {
                        company : this.GET_USER_INFORMATION[0].company ? this.GET_USER_INFORMATION[0].company.uuid : this.GET_USER_INFORMATION[0].user.company.uuid
                    }
                    this.getWebshop(payload)
                }
            })
            .catch(err => {
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.getUserInformation()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        getWebshop (data) {
            this.$store.dispatch('jitcontrol/getWebshop', data)
            .then(_ => {
                if (this.GET_WEBSHOPS.results.length > 0) {
                    this.selectedWebshop = this.GET_WEBSHOPS.results[0].uuid
                    this.getShopStatus()
                    this.getOrderRule()
                    this.getSuppliers()
                    if (this.GET_WEBSHOP_FILTER.length > 0) {
                        this.multipleFilterResult(this.GET_WEBSHOP_FILTER)
                    } else {
                        this.getWebshopOrders(this.GET_WEBSHOPS.results[0])
                    }
                }
            })
            .catch(err => {
                this.loading = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.getWebshop(data)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        changeWebshop (e) {
            const payload = {
                uuid : this.selectedWebshop
            }
            this.getWebshopOrders(payload)
        },
        changePageNumber (number) {
            this.loading = true
            this.$store.dispatch('jitcontrol/getWebshopOrders', { 
                page : number,
                limit : this.limit,
                uuid : this.selectedWebshop, 
                ordering : this.ordering ? this.orderingText : null
            })
            .then(_ => {
                this.loading = false
            }).catch((err) => {
                this.loading = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.changePageNumber(number)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        getWebshopOrders (data) {
            this.loading = true
            const payload = data
            payload.limit = this.limit
            payload.ordering = this.ordering ? this.orderingText : null
            this.$store.dispatch('jitcontrol/getWebshopOrders', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.getWebshopOrders(data)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                } 
            })        
        },
        proceedDeletion () {
            this.deleting = true
            const payload = {
                URL : this.selectedWebshop + this.$services.endpoints.WEBSHOP_ORDER_ENDPOINTS + `/${this.selectedData.uuid}`
            }
            this.$store.dispatch('jitcontrol/customDeleteRequest', payload)
            .then(res => {
                this.deleting = false
                this.getWebshopOrders({ uuid : this.selectedWebshop })
                this.$services.helpers.notification(this.$t('deletedOrderSuccess'), 'success', this)
                this.openDeletedModal = false
                this.selectedData = {}
            })
            .catch(err => {
                this.deleting = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.proceedDeletion()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Bus.emit('sign-out')
                    })
                } else {
                    this.$services.helpers.notification(err.response.data.message, 'error', this)
                }
            })
        },
        openStatusUpdateModal (data) {
            this.statusUpdateData = data
            this.openStatusModal = true
        },
        updateWebshopOrder (data) {
            const payload = {}
            if (data) {
                this.confirmingYes = true
                payload.mode = true
            } else {
                this.confirming = true
                payload.mode = false
            }
            payload.id = this.selectedWebshop,
            payload.order_id = this.statusUpdateData.webshop.uuid,
            payload.body = {
                status : this.statusUpdateData.value
            }
            this.$store.dispatch('jitcontrol/updateWebshopOrderStatus', payload)
            .then(_ => {
                this.confirmingYes = false
                this.confirming = false
                if (this.GET_WEBSHOPS.results.length > 0) {
                    this.getWebshopOrders(this.GET_WEBSHOPS.results[0])
                }
                this.$services.helpers.notification(this.$t('webshopStatusUpdated'), 'success', this)
                this.openStatusModal = false
            })
            .catch(err => {
                this.confirmingYes = false
                this.confirming = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.updateWebshopOrder(data)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                } else {
                    this.$services.helpers.notification(err.response.data, 'error', this)
                }
            })
        },
        toggleEventAction (e) {
            this.showActionBox = true
        },
        emitDeleteEvent (e) {
            this.selectedData = e
            this.showActionBox = false
            this.openDeletedModal = true
        },
        emitUpdateEvent (e) {
            // this.selectedData = e
            // this.showActionBox = false
            // this.openEditBox = true
        },
        emitViewEvent (e) {

        },
        getSuppliers () {
            if (this.selectedWebshop) {
                this.$store.dispatch('jitcontrol/getSuppliers', { uuid : this.selectedWebshop })
            } 
        },
        removeEvent () {
            Bus.emit('removeActionBox')
            this.showActionBox = false
        },
        removeFilterSearch (item) {
            this.$store.commit('jitcontrol/REMOVE_WEBSHOP_FILTER_ITEM', item)
            if (this.GET_WEBSHOP_FILTER.length > 0) {
                this.multipleFilterResult(this.GET_WEBSHOP_FILTER)
                return
            }
            this.getWebshopOrders({ uuid : this.selectedWebshop })
        },
        multipleFilterResult (emitData) {
            this.loading = true
            const payload = {
                id : this.selectedWebshop,
                query : []
            }

            const dateFilter = emitData.filter(el => el.mode === 'date')
            if (dateFilter.length > 0) {
                if (dateFilter[0].property.range === 'between') {
                    payload.query.push(`date_from=${dateFilter[0].property.start}&date_to=${dateFilter[0].property.end}`)
                } else if (dateFilter[0].property.range === 'equal') {
                    payload.query.push(`date=${dateFilter[0].property.date}`)
                } else if (dateFilter[0].property.range === 'less') {
                    payload.query.push(`date_to=${dateFilter[0].property.date}`)
                } else if (dateFilter[0].property.range === 'greater') {
                    payload.query.push(`date_from=${dateFilter[0].property.date}`)
                }
            }

            const totalFilter = emitData.filter(el => el.mode === 'amount')
            if (totalFilter.length > 0) {
                if (totalFilter[0].property.range === 'between') {
                    payload.query.push(parseFloat(totalFilter[0].property.start) < parseFloat(totalFilter[0].property.end) ? `amount_from=${totalFilter[0].property.start}&amount_to=${totalFilter[0].property.end}` : `amount_from=${totalFilter[0].property.end}&amount_to=${totalFilter[0].property.start}`)
                } else if (totalFilter[0].property.range === 'equal') {
                    payload.query.push(`amount=${totalFilter[0].property.amount}`)
                } else if (totalFilter[0].property.range === 'less') {
                    payload.query.push(`amount_to=${totalFilter[0].property.amount}`)
                } else if (totalFilter[0].property.range === 'greater') {
                    payload.query.push(`amount_from=${totalFilter[0].property.amount}`)
                }
            }

            const statusFilter = emitData.filter(el => el.mode === 'status')
            if (statusFilter.length > 0) {
                payload.query.push(`status=${statusFilter[0].property.status}`)
            }

            payload.query = `?${payload.query.join('&')}`

            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.multipleFilterResult(emitData)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        filterDate (data) {
            // console.log('data:::', data)
            this.loading = true
            const payload = {
                id : this.selectedWebshop,
                // query : `?date_from=${data.start}&date_to=${data.end}`
            }

            if (data.range === 'between') {
                payload.query = `?date_from=${data.start}&date_to=${data.end}`
            } else if (data.range === 'equal') {
                payload.query = `?date=${data.date}`
            } else if (data.range === 'less') {
                payload.query = `?date_to=${data.date}`
            } else if (data.range === 'greater') {
                payload.query = `?date_from=${data.date}`
            }

            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.filterDate()
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        filterStatus (data) {
            this.loading = true
            const payload = {
                id : this.selectedWebshop,
                query : `?status=${data.status}`
            }
            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.filterStatus(data)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        filterOrderAmount (data) {
            // console.log(data)
            this.loading = true
            const payload = {
                id : this.selectedWebshop,
            }
            if (data.range === 'between') {
                payload.query = parseFloat(data.start) < parseFloat(data.end) ? `?amount_from=${data.start}&amount_to=${data.end}` : `?amount_from=${data.end}&amount_to=${data.start}`
            } else if (data.range === 'equal') {
                payload.query = `?amount=${data.amount}`
            } else if (data.range === 'less') {
                payload.query = `?amount_to=${data.amount}`
            } else if (data.range === 'greater') {
                payload.query = `?amount_from=${data.amount}`
            }
            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.filterOrderAmount(data)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                } 
            })
        },
        shopResultNumber (e) {
            this.limit = parseInt(e.target.value)
            this.getWebshopOrders({ uuid : this.selectedWebshop })
        },
        filterOrderNumber (data) {
            if (data.status === 'asc') {
                this.sortOrderNumberAsc()
            } else {
                this.sortOrderNumberDesc()
            }
        },
        onDragEnd (dragResult) {
            const { isSource, payload, willAcceptDrop } = dragResult
            // console.log(isSource, payload, willAcceptDrop)
        },
        onDrop(dropResult){
            this.items = this.applyDrag(this.items, dropResult);
        },
        applyDrag(arr, dragResult){
            const { removedIndex, addedIndex, payload } = dragResult;

            if (removedIndex === null && addedIndex === null) return arr;
            const result = [...arr];
            let itemToAdd = payload;
            
            if (removedIndex !== null) {
                itemToAdd = result.splice(removedIndex, 1)[0];
            }
            if (addedIndex !== null) {
                result.splice(addedIndex, 0, itemToAdd);
            }
            return result;
        },
        sortChange (value) {
            this.loading = true
            this.ordering = true
            this.orderingText = value
            const payload = {
                id : this.selectedWebshop,
                query : `?ordering=${value}&limit=${this.limit}`
            }
            this.$store.dispatch('jitcontrol/getWebshopOrdersSearch', payload)
            .then(_ => { this.loading = false })
            .catch(err => { 
                this.loading = false 
                if (err.response.status === 401) {
                    this.$store.dispatch('auth/refreshToken', { refresh : this.USER_REFRESH })
                    .then(_ =>{
                        this.sortChange(value)
                    })
                    .catch(_ => {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        Bus.emit('sign-out')
                    })
                }
            })
        },
        sortOrderNumberAsc () {
            this.sortChange('webshop_order_number')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_NUM_ASC')
        },
        sortOrderNumberDesc () {
            this.sortChange('-webshop_order_number')

            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_NUM_DESC')
        },
        // sortTotalOrderAsc () {
        //     // this.sortChange('webshop_order_number')
        //     // this.$store.commit('jitcontrol/SORT_ORDER_TOTAL_ASC')
        // },
        // sortTotalOrderDesc () {
        //     // this.$store.commit('jitcontrol/SORT_ORDER_TOTAL_DESC')
        // },
        sortCustomerNameAsc () {
            this.sortChange('customer_name')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDERS_CUS_NAME_ASC')
        },
        sortCustomerNameDesc () {
            this.sortChange('-customer_name')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDERS_CUS_NAME_DESC')
        },
        sortWebshopOrderStatusAsc () {
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDERS_STATUS_ASC')
        },
        sortWebshopOrderStatusDesc () {
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDERS_STATUS_DESC')
        },
        sortWebshopOrderDateAsc () {
            this.sortChange('created_on')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_CREATED_DATE_ASC')
        },
        sortWebshopOrderDateDesc () {
            this.sortChange('-created_on')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_CREATED_DATE_DESC')
        },
        sortWebshopOrderDeliveryDateAsc () {
            this.sortChange('delivery_date')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_DELIVERY_DATE_ASC')
        },
        sortWebshopOrderDeliveryDateDesc () {
            this.sortChange('-delivery_date')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_DELIVERY_DATE_DESC')
        },
        sortWebshopOrderTotalAsc () {
            this.sortChange('items_total')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_TOTAL_ASC')
        },
        sortWebshopOrderTotalDesc () {
            this.sortChange('-items_total')
            // this.$store.commit('jitcontrol/SORT_WEBSHOP_ORDER_TOTAL_DESC')
        },
    }
}
</script>

<style lang="scss" scoped>
.table th {
    padding: .3rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}
.table tbody, td {
    padding: .3rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6 !important;
}
</style>